// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copy-text:hover button[data-v-2c0b6c21]{visibility:visible}", "",{"version":3,"sources":["webpack://./resources/js/Components/CopyText.vue"],"names":[],"mappings":"AAEI,yCACI,kBADR","sourcesContent":["\n.copy-text {\n    &:hover button {\n        visibility: visible\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
